import { Box } from '@mui/material';

/**
 * Decorative looping background video used across public search screens
 * (HeroSection, SocietyLoadingScreen, SocietyNotFoundPage, PublicErrorSection).
 *
 * Serves WebM/VP9 to Chrome, Firefox and Edge; falls back to H.264 MP4 for
 * Safari. Both encodes are 720p re-encodes of the original 1080p HEVC source
 * (~800 KB each vs 17 MB). `preload="none"` keeps the download off the
 * critical path — autoPlay+muted starts playback after hydration.
 */
export function BackgroundVideo() {
  return (
    <Box
      component="video"
      autoPlay
      muted
      loop
      playsInline
      preload="none"
      aria-hidden
      sx={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center 56%',
        pointerEvents: 'none',
      }}
    >
      <source src="/images/background.webm" type="video/webm" />
      <source src="/images/background-h264.mp4" type="video/mp4" />
    </Box>
  );
}
